import { FE_POSTHOG_API_KEY_251001 } from "@faire/web-settings/FE_POSTHOG_API_KEY_251001";

import { getSettingValueWithoutAssignment } from "./__internal__/getSetting";

export const getSettingPosthogApiKey = (): string | undefined =>
  getSettingValueWithoutAssignment(FE_POSTHOG_API_KEY_251001, undefined);
